import { connect } from 'react-redux';
import { getIsSearchModalShown } from '../../../../SiteHeader/redux/selectors';
import { openSearchModal, closeSearchModal, } from '../../../../SiteHeader/redux/actions';
var mapStateToProps = function (state) { return ({
    isSearchModalShown: getIsSearchModalShown(state),
}); };
var mapDispatchToProps = {
    openSearchModal: openSearchModal,
    closeSearchModal: closeSearchModal,
};
export default connect(mapStateToProps, mapDispatchToProps);
//# sourceMappingURL=SearchIconButton.container.js.map